const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].Page_1[0].Veteran_Name_Subform[0].SSN_Text_Field[0]"
     },
     examDate: {
        value: "",
        dbqName: "form1[0].Page_1[0].Veteran_Name_Subform[0].Date_Text_Field[0]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].Page_8[0].Section_XI_Remarks_Subform[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].Page_8[0].Section_XI_Remarks_Subform[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].Page_8[0].Section_XI_Remarks_Subform[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].Page_8[0].Section_XI_Remarks_Subform[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].Page_8[0].Section_XI_Remarks_Subform[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].Page_8[0].Section_XI_Remarks_Subform[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].Page_8[0].Section_XI_Remarks_Subform[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Diabetic_nephropathy[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Diabetic_nephropathy_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Glomerulonephritis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Glomerulonephritis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Hydronephrosis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Hydronephrosis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Interstitial_nephritis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Interstitial_nephritis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Kidney_Transplant[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Kidney_transplant_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Nephrosclerosis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Nephrosclerosis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Nephrolithiasis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Nephrolithiasis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_artery_stenosis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_artery_stenosis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Ureterolithiasis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Ureterolithiasis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Neoplasm_kidney[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Neoplasm_kidney_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Cholesterol_emboli[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Cholesterol_emboli_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Cystic_kidney_disease[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Cystic_kidney_disease_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Nephrocalcinosis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Nephrocalcinosis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_cortical_necrosis_check_box[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_cortical_necrosis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_tubular_disorders[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_tubular_disorder_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Kidney_abscess[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Kidney_abscess_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Chronic_pyelonephritis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Pyelonephritis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Kidney_removal[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Kidney_removal_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Chronic_nehphritis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Chronic_nephritis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Atherosclerotic_renal_disease[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Atherosclerotic_renal_disease_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Ureter_stricture[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Ureter_stricture_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Diabetes_Renal_Involvement[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Diabetes_renal_involvement_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Papillary_necrosis[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Papilary_necrosis_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_amyloid_disease[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Renal_amyloid_disease_date[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Congenital_or_inherited_kidney_disorder[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Congenital_inherited_kidney_disoorder_date[0]",
        },
        {
            type: "text",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Otherdiagnosis1[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Other_diagnosis_1_date[0]",
        },
        {
            type: "text",
            dbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Otherdiagnosis2[0]",
            dateDbqName: "form1[0].Page_2[0].Section_1_Diagnosis_Subform[0].Other_diagnosis_2_date[0]",
        },        
    ]

}

export default ssn ;